<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="returnModal" width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>برگشت فاکتور {{ selected.invoiceCode }} از فروش</h4>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-4">
            <h5 class="text-right">آیا از برگشت فروش ثبت شده اطمینان دارید؟</h5>
            <div class="text-left pt-4">
              <v-btn class="red white--text mx-1" @click="returnModal = false"
                >خیر</v-btn
              >
              <v-btn
                color="primary"
                class="mx-1"
                :loading="busy"
                @click="submit"
                >بله</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />

    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="$router.currentRoute.path == '/shop/salesInvoices'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <v-row>
          <v-col>
            <h5 class="m-0 pt-1">مدیریت فاکتورهای فروش</h5>
          </v-col>
          <v-col>
            <router-link
              to="/shop/newSalesInvoice"
              style="float: left"
              class="btn btn-dark"
            >
              + ثبت فاکتور جدید +</router-link
            >
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0">
            <v-col cols="3">
              <date-picker
                placeholder="تاریخ شروع"
                v-model="startDate"
                :editable="true"
              ></date-picker
            ></v-col>
            <v-col cols="3">
              <date-picker
                placeholder="تاریخ پایان"
                v-model="endDate"
                :editable="true"
              ></date-picker
            ></v-col>
            <v-col cols="4">
              <v-select
                outlined
                dense
                class="v-select"
                v-model="invoiceType"
                :items="invoiceTypes"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <b-btn class="btn btn-dark" @click="searchInvoices()"
                >جستجو</b-btn
              >
            </v-col>
          </v-row>
        </template>
        <v-row class="p-0">
          <v-col cols="12" class="pb-0 mt-3">
            <v-text-field
              v-model="userInput"
              placeholder="جستجو"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <b-table
          responsive
          show-empty
          :items="invoices"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="userInput"
          id="invoices-table"
          @filtered="onFiltered"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(shopCustomerName)="data">
            <div style="text-align: center; vertical-align: middle">
              <router-link :to="'/shop/customer/' + data.item.shopCustomerId">{{
                data.value
              }}</router-link>
            </div>
          </template>
          <template v-slot:cell(invoiceCode)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }} ({{ data.item.type }})
            </div>
          </template>

          <template v-slot:cell(totalCost)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }} ریال
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn
                :disabled="gettingReceipt"
                class="mr-1"
                variant="primary"
                @click="print(data.item)"
                >چاپ رسید</b-btn
              >
              <b-btn
                v-if="data.item.status != 'برگشت خورده'"
                class="mr-1 red white--text"
                @click="openModal(data.item)"
                >برگشت از فروش</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="invoices-table"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false">
        <table
          class="mainTable m-3 p-4 h-100 w-100"
          style="break-inside: avoid"
        >
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      margin-bottom: 10px;
                    "
                  >
                    <div style="text-align: center">
                      <span style="font-size: 20px">فاکتور فروش</span>
                    </div>
                    <br />
                    <div>
                      <table style="border: 0px solid black !important">
                        <tr>
                          <td style="border: 0px solid black !important">
                            نام مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerName
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            شماره فاکتور:
                            <span style="font-size = 16px">{{
                              printInvoice.code
                            }}</span>
                            (چاپ مجدد)
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            کد مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerCode
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            تاریخ صدور:
                            <span style="font-size = 16px">{{
                              printInvoice.date
                            }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            نوع مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerType
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            ساعت صدور:
                            <span style="font-size = 16px">{{
                              printInvoice.time
                            }}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <br />
                  </div>
                  <b-table
                    bordered
                    :fields="selectedFields"
                    :items="printInvoice.details"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value.toLocaleString() }} ریال
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                        ریال
                      </div>
                    </template>
                  </b-table>
                  <br />

                  <table
                    v-if="printInvoice.income"
                    style="
                      border: 0px solid black !important;
                      break-inside: avoid;
                    "
                  >
                    <tr>
                      <td
                        v-if="printInvoice.income.type == 'چک'"
                        style="border: 0px solid black !important"
                      >
                        <span>
                          {{ "شیوه پرداخت: " + printInvoice.income.type }}
                        </span>
                      </td>
                      <td
                        v-if="printInvoice.income.type == 'چک'"
                        style="border: 0px solid black !important"
                      >
                        <span>
                          {{ "شماره چک: " + printInvoice.income.chequeNo }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        v-if="printInvoice.income.type == 'چک'"
                        style="border: 0px solid black !important"
                      >
                        <span>
                          {{ "نام بانک: " + printInvoice.income.chequeBank }}
                        </span>
                      </td>
                      <td
                        v-if="printInvoice.income.type == 'چک'"
                        style="border: 0px solid black !important"
                      >
                        <span>
                          {{ "تاریخ چک: " + printInvoice.income.chequeDate }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        v-if="printInvoice.income.type == 'چک'"
                        style="border: 0px solid black !important"
                      >
                        <span>{{
                          "شماره صیاد: " +
                          (printInvoice.income.chequeSayyad
                            ? printInvoice.income.chequeSayyad
                            : "-")
                        }}</span>
                      </td>
                    </tr>
                  </table>

                  <div v-if="printInvoice.income">
                    <span>
                      {{
                        "مبلغ کل: " +
                        Number(printInvoice.totalCost).toLocaleString()
                      }}
                      ریال
                    </span>
                    <div
                      v-if="printInvoice.income.type != 'چک'"
                      style="float: left"
                    >
                      <span>
                        نوع پرداخت:
                        {{
                          printInvoice.type == "قطعی"
                            ? "قطعی - پرداخت در لحظه"
                            : "امانی - پرداخت اعتباری"
                        }}
                      </span>
                      <span v-if="printInvoice.type == 'قطعی'">{{
                        " (" + printInvoice.income.type + ")"
                      }}</span>
                    </div>
                  </div>
                  <br />
                  <div
                    style="
                      border: 1px solid grey;
                      border-radius: 10px;
                      min-height: 80px;
                      padding: 10px;
                      break-inside: avoid;
                    "
                  >
                    <span> توضیحات: {{ printInvoice.description }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
    <!-- receipt -->
    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import router from "../../router";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },

  data: function () {
    return {
      guide: false,

      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      invoiceType: "definite",
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      TotalRows: "",
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      T: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      busy: false,
      filter: null,
      invoices: [],
      selected: "",
      newInvoice: {
        customerBalance: "",
      },
      progress: false,
      customer: {},
      printInvoice: {},
      returnModal: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    openModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt();
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    submit() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/return",
        {
          shopInvoiceId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.returnModal = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.busy = false;
        });
    },
    getCustomerInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customer.name = res.data.name;
            this.customer.mobile = res.data.mobile;
            this.customer.email = res.data.email;
            this.customer.economicCode = res.data.economicCode;
            this.customer.phone = res.data.phone;
            this.customer.address = res.data.address;
            this.customer.natCode = res.data.natCode;
            this.customer.type = res.data.type;
            this.customer.balance = res.data.balance;
            this.progress = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    searchInvoices() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/invoices",
        {
          type: this.invoiceType,
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.invoices = res.data;
            this.TotalRows = this.invoices.length;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
          this.vLoading = false;
        });
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    totalCost() {
      return 1000;
    },
  },

  mounted() {
    this.searchInvoices();
    this.getCustomers();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}
@media print {
  td {
    font-family: "iransans" !important;
    border-radius: 3px;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
